document.addEventListener('DOMContentLoaded', () => {
    const bundleContainer = document.querySelector('.bundle-options');
    if (!bundleContainer) return;

    // Check if we are on the correct template if required by user
    const isV2Template = document.body.classList.contains('nitropress-ds-v2');
    console.log('Bundle Options: nitropress-ds-v2 template detected:', isV2Template);

    const options = bundleContainer.querySelectorAll('.bundle-option');
    const mainProductInfo = bundleContainer.closest('product-info') || document.querySelector('product-info');
    const mainProductForm = mainProductInfo ? mainProductInfo.querySelector('product-form form') : document.querySelector('product-form form');
    const upsellVariantId = bundleContainer.dataset.upsellVariantId;
    const stickyAddToCart = document.getElementById('sticky-add-to-cart');

    options.forEach(option => {
        option.addEventListener('click', () => {
            options.forEach(opt => opt.classList.remove('active'));
            option.classList.add('active');
            const radio = option.querySelector('input[type="radio"]');
            if (radio) radio.checked = true;

            console.log('Bundle Options: Selected option changed to:', option.dataset.value);
        });
    });

    /**
     * Shared function to add bundle items to cart
     */
    async function handleBundleAddToCart(event, triggerElement) {
        const selectedOption = bundleContainer.querySelector('.bundle-option.active');

        // Only run on V2 template as requested by user if they want to target specifically
        // Or if the bundle option 'bundle' is selected
        if (selectedOption && selectedOption.dataset.value === 'bundle') {
            console.log('Bundle Options: Intercepting add to cart for bundle.');

            event.preventDefault();
            event.stopImmediatePropagation();

            const submitButton = triggerElement || (mainProductForm ? mainProductForm.querySelector('[type="submit"]') : null);
            if (submitButton && submitButton.hasAttribute('aria-disabled')) return;

            if (submitButton) {
                submitButton.setAttribute('aria-disabled', true);
                submitButton.classList.add('loading');
            }

            if (!upsellVariantId) {
                console.error('Bundle Options: Upsell Variant ID not found');
                if (submitButton) {
                    submitButton.removeAttribute('aria-disabled');
                    submitButton.classList.remove('loading');
                }
                return;
            }

            // Get main variant ID. 
            // For main form, it's in the input. 
            // For sticky bar, we might need to get it from the global variable or a data attribute if available,
            // but on this page, the main form input usually updates.
            let mainVariantId = mainProductForm ? mainProductForm.querySelector('input[name="id"]').value : null;

            // Fallback for sticky bar if main form is weird
            if (!mainVariantId && window.selectedVariantId) {
                mainVariantId = window.selectedVariantId;
            }

            const qty = mainProductForm ? (mainProductForm.querySelector('input[name="quantity"]')?.value || 1) : 1;

            if (!mainVariantId) {
                console.error('Bundle Options: Main Variant ID not found');
                if (submitButton) {
                    submitButton.removeAttribute('aria-disabled');
                    submitButton.classList.remove('loading');
                }
                return;
            }

            console.log('Bundle Options: Adding Bundle:', { main: mainVariantId, upsell: upsellVariantId, qty: qty });

            const cartDrawer = document.querySelector('cart-drawer');
            const cartNotification = document.querySelector('cart-notification');
            const cartElement = cartDrawer || cartNotification;

            let sectionsToRender = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
            if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
                sectionsToRender = cartElement.getSectionsToRender().map(s => s.id || s.section);
            }

            const formData = {
                'items': [
                    { 'id': mainVariantId, 'quantity': qty },
                    { 'id': upsellVariantId, 'quantity': qty }
                ],
                'sections': sectionsToRender,
                'sections_url': window.location.pathname
            };

            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(formData)
                });

                const data = await response.json();

                if (response.ok) {
                    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: mainVariantId,
                            cartData: data
                        });
                    }

                    if (cartElement && typeof cartElement.renderContents === 'function') {
                        cartElement.renderContents(data);
                    }
                } else {
                    console.error('Error adding bundle:', data.description || data.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
            } finally {
                if (submitButton) {
                    submitButton.removeAttribute('aria-disabled');
                    submitButton.classList.remove('loading');
                }
            }
        }
    }

    // Listener for main form
    if (mainProductForm) {
        mainProductForm.addEventListener('submit', (e) => handleBundleAddToCart(e), { capture: true });
    }

    // Listener for sticky bar add to cart
    if (stickyAddToCart) {
        console.log('Bundle Options: Attaching listener to sticky add to cart');
        stickyAddToCart.addEventListener('click', (e) => handleBundleAddToCart(e, stickyAddToCart), { capture: true });
    }
});
